import { coreService } from "../../../../services/coreService";
import { buildQuery } from "../../../../lib/network";

export const getInspections = (headers: any, recordId?: string, inspectableId?: string) => () => {
  return buildQuery(
    coreService.inspectionsList(
      { record_type: "permit", record_id: recordId, inspectable_id: inspectableId, inspectable_type: "PermitsStep" },
      { headers },
    ),
    (response) => {
      return response.data;
    },
  );
};
